import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/common/toast.service';
import { Observable,} from 'rxjs';
import { toastMsg } from 'src/app/modules/auth/auth-constants';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass]
})
export class ToastComponent implements OnInit {
  msg$!: Observable<any>;
  msg!:toastMsg
  constructor(private toast: ToastService) {}
  ngOnInit(): void {
    this.msg$ = this.toast.toast$;
    this.msg$.subscribe((x:toastMsg)=>{
      this.msg = x
    })
  }

  close_msg() {
    this.toast.setToast(null);
  }
}
